import StudioTemplateAPI from 'dashboard/api/studio/template';
import { createStore } from '../captain/storeFactory';

export default createStore({
  name: 'StudioTemplate',
  API: StudioTemplateAPI,
});
